<template>
  <div class="audio-player-component audio-player" :style="{'height': height}">
    <audio v-if="!recreateAudio" :style="{'height': height}" class="audio-player" id="myAudio" controls controlsList="nodownload">
      <source :src="src" type="audio/mp3" >
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>

  export default {
      data() {
        return {
          recreateAudio: false
        }
      },
      props: {
        id: {
            type: String,
            required: false,
            default: ''
        },
        src: {
            type: String,
            required: false,
            default: ''
        },
        height: {
          type: String,
          required: false,
          default: '32px'
        }
      },
      watch: {
        src:{
          handler: function(n) {
            this.recreateAudio = true
            this.$nextTick(()=>{
              this.recreateAudio = false
            })
          },
          immediate: true,
          deep: true
        },
      }
    }
</script>

<style lang="scss">
  .audio-player{
    width:100%;
    height:32px
  }
</style>
